/**
 * https://amplitude.com/docs/sdks/analytics/browser/browser-sdk-2
 * */

import { init, setUserId, track } from '@amplitude/analytics-browser';
import { CONFIG } from 'config/environment_variables';

// Initialize Amplitude
export const initAmplitude = () => {
  init(CONFIG.AMPLITUDE_KEY, undefined, {
    defaultTracking: true,
    autocapture: false,
  });
};

// Set Amplitude User ID
export const setAmplitudeUserId = (id: string) => {
  setUserId(id);
};

// Track an event
export const amplitudeTrack = (
  event: string,
  options?: Record<string, unknown>,
) => {
  track(event, options);
};
